/* dipcraft.js — DipCraft Shopify Theme JavaScript */

/* ── TOAST ── */
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 3000);
}

/* ── CART BUBBLE UPDATE ── */
function updateCartBubble() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const bubble = document.getElementById('cart-bubble');
      if (bubble) bubble.textContent = cart.item_count;
    });
}

/* ── AJAX ADD TO CART (Quick-add buttons on product cards) ── */
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.btn-add[data-product-title]');
  if (!btn) return;
  const form = btn.closest('.quick-add-form');
  if (!form) return;
  e.preventDefault();
  btn.disabled = true;
  btn.textContent = '…';
  const formData = new FormData(form);
  fetch('/cart/add.js', { method: 'POST', body: formData })
    .then(r => r.json())
    .then(item => {
      showToast(item.product_title + ' added to cart!');
      updateCartBubble();
      btn.textContent = '✓ Added';
      setTimeout(() => { btn.textContent = '+ Add'; btn.disabled = false; }, 2000);
    })
    .catch(() => {
      showToast('Something went wrong. Please try again.');
      btn.textContent = '+ Add';
      btn.disabled = false;
    });
});

/* ── PREORDER QTY & TOTAL CALCULATOR ── */
let preorderQty = 1;

function changeQty(d) {
  preorderQty = Math.max(1, preorderQty + d);
  const display = document.getElementById('qty-display');
  const hidden = document.getElementById('qty-hidden');
  if (display) display.textContent = preorderQty;
  if (hidden) hidden.value = preorderQty;
  updateTotal();
}

function updateTotal() {
  const sel = document.getElementById('sauce-select');
  if (!sel) return;
  const opt = sel.options[sel.selectedIndex];
  const price = opt ? parseFloat(opt.getAttribute('data-price')) : 0;
  const sub = document.getElementById('subtotal-val');
  const tot = document.getElementById('total-val');
  const hidden = document.getElementById('estimated-total-hidden');
  if (!price || isNaN(price)) {
    if (sub) sub.textContent = '—';
    if (tot) tot.textContent = '—';
    return;
  }
  const total = (price * preorderQty).toFixed(2);
  if (sub) sub.textContent = '$' + total;
  if (tot) tot.textContent = '$' + total;
  if (hidden) hidden.value = '$' + total;
}

const sauceSelect = document.getElementById('sauce-select');
if (sauceSelect) sauceSelect.addEventListener('change', updateTotal);

/* ── FAQ ACCORDION ── */
function toggleFaq(el) {
  const item = el.closest('.faq-item');
  if (!item) return;
  item.classList.toggle('open');
}

/* ── STAR RATING ── */
function setRating(n) {
  const stars = document.querySelectorAll('#star-rating .star');
  const hidden = document.getElementById('rating-hidden');
  stars.forEach((s, i) => {
    s.style.color = i < n ? '#E8961A' : '#D4C0A8';
  });
  if (hidden) hidden.value = n;
}

/* ── HOVER STAR EFFECT ── */
document.addEventListener('mouseover', function(e) {
  const star = e.target.closest('#star-rating .star');
  if (!star) return;
  const stars = star.closest('#star-rating').querySelectorAll('.star');
  const idx = Array.from(stars).indexOf(star);
  stars.forEach((s, i) => {
    s.style.color = i <= idx ? '#E8961A' : '#D4C0A8';
  });
});
document.addEventListener('mouseout', function(e) {
  if (!e.target.closest('#star-rating')) return;
  const hidden = document.getElementById('rating-hidden');
  const saved = hidden ? parseInt(hidden.value) : 0;
  const stars = document.querySelectorAll('#star-rating .star');
  stars.forEach((s, i) => { s.style.color = i < saved ? '#E8961A' : '#D4C0A8'; });
});

/* ── PRODUCT IMAGE THUMBNAIL ACTIVE STATE ── */
document.addEventListener('click', function(e) {
  const thumb = e.target.closest('.thumb');
  if (!thumb) return;
  document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
});

/* ── INIT ── */
updateCartBubble();
